import { IdentityWebModelsUserUserClaimDto as Claim } from '@services/identity-api/models';
import { InjectionKey } from 'vue';
import { Claims, FlattenedPermissions } from './types';

export const containsPermission = (claims: Array<Claim>, permission: string) => {
  const authorization = claims.filter(a => a.value === permission && a.type === 'Permission');
  return authorization.length > 0;
};

export const authorizationProviderSymbol: InjectionKey<AuthorizationProvider> = Symbol('AuthorizationProvider');

export interface AuthorizationProvider {
  // eslint-disable-next-line no-unused-vars
  getClaims: () => Promise<Claims>;
  hasPermission: (permission: FlattenedPermissions) => Promise<boolean>;
  type: () => string;
  handleUnauthorized: (sessieVerlaten?: boolean) => void;
  signOut: (sessieVerlaten?: boolean) => void;
}
